function getQS(key: string) {
  key = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
  const results = regex.exec(location.search);
  if (results !== null) {
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  return null;
}

function reloadPage() {
  const next = getQS('next');
  if (next) {
    window.location.href = next;
  } else {
    location.reload();
  }
}

export function waitAndReload() {
  setTimeout(() => {
    // this case is an exception to the signup and login process where if a user is trying to purchase
    // a gift card from /gift, we want to take them to the checkout process for the gift card
    // instead of going through the quiz or regular flow
    // clicking this button will proceed the user to pay for the gift card but we must first remove
    // the class that prevents the user from proceeding
    $('.require-signup').removeClass('require-signup');
    if ($('.auto-click').length) {
      $('.auto-click').trigger('click');
    } else {
      reloadPage();
    }
  }, 500);
}
